import { Flame } from "lucide-react";

export const RotatingBadge = ({ className = "" }) => (
  <div aria-hidden="true" className={`relative h-28 w-28 ${className}`}>
    <svg viewBox="0 0 120 120" className="h-full w-full animate-spin-slow">
      <defs>
        <path
          id="badge-circle"
          d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0"
          fill="none"
        />
      </defs>
      <text
        className="fill-charcoal font-mono font-bold uppercase"
        style={{ fontSize: "11px", letterSpacing: "2.6px" }}
      >
        <textPath href="#badge-circle">
          Ayam Goreng Basah • Khas Bandung •
        </textPath>
      </text>
    </svg>
    <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-bumbu text-canvas shadow-lg">
      <Flame className="h-6 w-6" />
    </span>
  </div>
);
